<template>
  <div class="list__action__item--content">
    <div class="flex-row flex__between">
      <p class="name margin-0">
        {{ action.creatorName }}
      </p>
      <div class="time font-size__small">
        <i class="fal fa-clock"></i>
        {{ action.createTime | convertToLabelFilter }}
      </div>
    </div>
    <div>
      <p
        :class="[
          'action-type flex-row flex__left inline-flex',
          classColorByActionName()
        ]"
      >
        <i :class="['font-size__small', classIconByActionName()]"></i>
        <span class="font-size__small no_wrap">
          Hiệu chỉnh văn bản
        </span>
      </p>
    </div>
  </div>
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import PopoverWord2 from "../common/popover-word-2";

  export default {
    name: "history-hieuchinh",
    components: {PopoverWord2},
    props: ["action"],
    filters: {
      convertToLabelFilter
    },
    data() {
      return {};
    },
    methods: {

      classIconByActionName() {
        return "fal fa-pen-square";
      },

      classColorByActionName() {
        return "color__blue";
      },
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/history-hieuchinh.vue